import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/cnn'
const QUERY_KEY = 'cnn'

export const useGetCnn = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config,
  )

export const usePostCnn = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const usePatchCnn = (config = {}) =>
  useMutation((updatedData) => API.patch(ENDPOINT, updatedData), config)

export const useDeleteCnn = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)

export const useGetCnnPoint = ({ customerId, ...query } = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'points', customerId, query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/points/${customerId}`, query))).data,
    config,
  )

export const useGetCnnPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'points', query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/points`, query))).data,
    config,
  )

export const useExportCnnPoints = (config = {}) =>
  useMutation(
    (data) => API.post(`${ENDPOINT}/points/export`, data, { responseType: 'blob' }),
    config,
  )
